import { BreakpointValue, breakpointQuery } from '@utils/breakpoints'
import { useEffect, useState } from 'react'

export function useBreakpoint(
  bpoint: BreakpointValue,
  options?: { max?: boolean }
) {
  const { max = false } = options ?? {}
  const [active, setActive] = useState<boolean>(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia(breakpointQuery(bpoint, { max }))

    function breakpointChange(e: MediaQueryListEvent) {
      setActive(e.matches)
    }

    mediaQuery.addEventListener('change', breakpointChange)
    setActive(mediaQuery.matches)
  }, [bpoint, max])

  return active
}
